module.exports = __webpack_public_path__ + "static/media/sf_hotel_2.cd30bd40.jpg";